import { SUPER_USER_ONLY_COLOR } from '@/theme/usePixydocsTheme'
import { Document } from '@/types/documents'
import { Paper, Typography } from '@mui/material'

type MetaDataDetailsProps = {
  document: Document
}

export default function MetaDataDetails({ document }: MetaDataDetailsProps) {
  return (
    <>
      <Typography variant="caption" sx={{ color: SUPER_USER_ONLY_COLOR }}>
        Super User Only
      </Typography>
      <Paper
        elevation={0}
        variant="outlined"
        sx={{
          p: 1,
          fontSize: '0.875rem',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          fontFamily: 'monospace',
        }}
      >
        {JSON.stringify(document.metadata, null, 4)}
      </Paper>
    </>
  )
}
